// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Anleitungen als Kacheln: Kategorie links, Kacheln rechts */
.guide-rows {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  border-top: 2px solid var(--text-primary);
}

.guide-row {
  display: grid;
  grid-template-columns: minmax(0, 12rem) minmax(0, 1fr);
  gap: 1rem 2rem;
  padding: 1.25rem 0;
  border-bottom: 1px solid var(--border-primary);
  scroll-margin-top: calc(var(--header-height) + 1rem);
}

.guide-row-title {
  margin: 0;
  padding-top: 0.2rem;
  font-family: var(--font-display);
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 1.15;
  text-transform: uppercase;
}

.guide-tiles {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 17rem), 1fr));
  gap: 0.75rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.guide-tile {
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  height: 100%;
  padding: 0.7rem 0.75rem 0.7rem 0.7rem;
  border: 1px solid transparent;
  color: var(--text-primary);
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.guide-tile:hover,
.guide-tile:focus-visible {
  background: var(--bg-secondary);
  border-color: var(--border-primary);
  color: var(--text-primary);
}

.guide-tile-text {
  display: grid;
  gap: 0.2rem;
  min-width: 0;
  padding-top: 0.1rem;
}

.guide-tile-title {
  font-weight: 700;
  line-height: 1.3;
}

.guide-tile:hover .guide-tile-title {
  color: var(--accent-primary);
}

.guide-tile-desc {
  font-size: 0.88rem;
  line-height: 1.45;
  color: var(--text-secondary);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media (max-width: 760px) {
  .guide-row {
    grid-template-columns: minmax(0, 1fr);
    gap: 0.6rem;
  }

  .guide-tile {
    padding-inline: 0;
  }

  .guide-tile:hover {
    background: transparent;
    border-color: transparent;
  }
}

/* Produktseite (ohne Beschreibung): auf dem Handy zwei Kacheln nebeneinander */
@media (max-width: 760px) {
  .guide-tiles-compact {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.5rem;
  }

  .guide-tiles-compact .guide-tile {
    flex-direction: column;
    gap: 0.45rem;
    padding: 0.6rem;
    border: 1px solid var(--border-primary);
    background: var(--bg-secondary);
  }

  .guide-tiles-compact .icon-tile {
    width: 2.6rem;
    height: 2.6rem;
  }

  .guide-tiles-compact .guide-tile-title {
    font-size: 0.92rem;
    line-height: 1.25;
    hyphens: auto;
    overflow-wrap: break-word;
  }

  .guide-row:has(.guide-tiles-compact) {
    padding: 0.9rem 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/GuideTiles/GuideTiles.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;EACE,aAAa;EACb,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,cAAc;EACd,kBAAkB;EAClB,8CAA8C;EAC9C,oDAAoD;AACtD;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uEAAuE;EACvE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,6BAA6B;EAC7B,0BAA0B;EAC1B,8DAA8D;AAChE;;AAEA;;EAEE,+BAA+B;EAC/B,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;EAC3B;AACF;;AAEA,+EAA+E;AAC/E;EACE;IACE,gDAAgD;IAChD,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,uCAAuC;IACvC,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Anleitungen als Kacheln: Kategorie links, Kacheln rechts */\n.guide-rows {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  border-top: 2px solid var(--text-primary);\n}\n\n.guide-row {\n  display: grid;\n  grid-template-columns: minmax(0, 12rem) minmax(0, 1fr);\n  gap: 1rem 2rem;\n  padding: 1.25rem 0;\n  border-bottom: 1px solid var(--border-primary);\n  scroll-margin-top: calc(var(--header-height) + 1rem);\n}\n\n.guide-row-title {\n  margin: 0;\n  padding-top: 0.2rem;\n  font-family: var(--font-display);\n  font-size: 1.2rem;\n  font-weight: 600;\n  line-height: 1.15;\n  text-transform: uppercase;\n}\n\n.guide-tiles {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(min(100%, 17rem), 1fr));\n  gap: 0.75rem;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.guide-tile {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.9rem;\n  height: 100%;\n  padding: 0.7rem 0.75rem 0.7rem 0.7rem;\n  border: 1px solid transparent;\n  color: var(--text-primary);\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.guide-tile:hover,\n.guide-tile:focus-visible {\n  background: var(--bg-secondary);\n  border-color: var(--border-primary);\n  color: var(--text-primary);\n}\n\n.guide-tile-text {\n  display: grid;\n  gap: 0.2rem;\n  min-width: 0;\n  padding-top: 0.1rem;\n}\n\n.guide-tile-title {\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.guide-tile:hover .guide-tile-title {\n  color: var(--accent-primary);\n}\n\n.guide-tile-desc {\n  font-size: 0.88rem;\n  line-height: 1.45;\n  color: var(--text-secondary);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n@media (max-width: 760px) {\n  .guide-row {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 0.6rem;\n  }\n\n  .guide-tile {\n    padding-inline: 0;\n  }\n\n  .guide-tile:hover {\n    background: transparent;\n    border-color: transparent;\n  }\n}\n\n/* Produktseite (ohne Beschreibung): auf dem Handy zwei Kacheln nebeneinander */\n@media (max-width: 760px) {\n  .guide-tiles-compact {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 0.5rem;\n  }\n\n  .guide-tiles-compact .guide-tile {\n    flex-direction: column;\n    gap: 0.45rem;\n    padding: 0.6rem;\n    border: 1px solid var(--border-primary);\n    background: var(--bg-secondary);\n  }\n\n  .guide-tiles-compact .icon-tile {\n    width: 2.6rem;\n    height: 2.6rem;\n  }\n\n  .guide-tiles-compact .guide-tile-title {\n    font-size: 0.92rem;\n    line-height: 1.25;\n    hyphens: auto;\n    overflow-wrap: break-word;\n  }\n\n  .guide-row:has(.guide-tiles-compact) {\n    padding: 0.9rem 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
